module.exports = __webpack_public_path__ + "img/image-finish.c8fca112.svg";